module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-clientes"
  }, [(_vm.seleccionado) ? _c('div', [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Cliente " + _vm._s(_vm.clienteSeleccionado.codigo) + " " + _vm._s(_vm.clienteSeleccionado.nombre) + " seleccionado")])]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": _vm.deseleccionar
    }
  }, [_vm._v("Deseleccionar")])]) : _c('div', [_vm._m(0), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "button is-small",
    class: {
      'is-loading': _vm.isUpdating
    },
    on: {
      "click": _vm.actualizarTodos
    }
  }, [_vm._v("Actualizar todos")])]), _c('div', {
    staticClass: "agregar"
  }, [_c('span', [_vm._v("Ingresa el codigo del cliente para agregregarlo")]), _c('div', {
    staticClass: "field d-flex ai-center jc-center"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('v-text-field', {
    staticClass: "is-empresa",
    attrs: {
      "type": "number",
      "label": "Codigo de cliente",
      "solo": "solo",
      "dense": "dense"
    },
    model: {
      value: (_vm.codigoClienteAgregar),
      callback: function($$v) {
        _vm.codigoClienteAgregar = $$v
      },
      expression: "codigoClienteAgregar"
    }
  })], 1)]), _c('button', {
    staticClass: "button is-small",
    class: {
      'is-loading': _vm.isAdding
    },
    on: {
      "click": _vm.agregar
    }
  }, [_vm._v("Agregar")])]), _c('div', {
    staticClass: "body"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(1), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_vm._v(_vm._s(o.codigo))]), _c('td', [_vm._v(_vm._s(o.nombre))]), _c('td', [_c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.ver(o)
        }
      }
    }, [_vm._v("Ver")]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.remove(o)
        }
      }
    }, [_vm._v("Eliminar")])])])])
  }), 0)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Clientes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Codigo")]), _c('th', [_vm._v("Nombre")]), _c('th')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4114d76","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Cliente_List.vue
// module id = 522
// module chunks = 1